import Vue from 'vue';
import Vuex from 'vuex';
import Firebase from 'firebase';

Vue.use(Vuex);

export const store = new Vuex.Store({
  state: {
    user: null,
    workout: null
  },
  getters: {
    getUser: state => {
      return state.user;
    },
    getWorkouts: state => {
      return state.workout;
    }
  },
  mutations: {
    setUser: state => {
      state.user = Firebase.auth().currentUser;
    },
    setWorkout: state => {
      state.workout = Firebase.database().ref('workouts/');
    }
  },
  actions: {
    setUser: context => {
      context.commit('setUser');
    }
  }
});



// WEBPACK FOOTER //
// ./src/store/store.js